import React, {ReactNode} from "react";
import {AIProvider, AIProviderSettingsProps} from "../AIProvider";
import {AnthropicSettings} from "./AnthropicSettings";

export class AnthropicProvider implements AIProvider {
    priority = 4
    name = 'Anthropic'
    icon = <svg version="1.1" id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 92.2 65" width="18px" height="18px" >
        <path d="M66.5,0H52.4l25.7,65h14.1L66.5,0z M25.7,0L0,65h14.4l5.3-13.6h26.9L51.8,65h14.4L40.5,0C40.5,0,25.7,0,25.7,0z
	 M24.3,39.3l8.8-22.8l8.8,22.8H24.3z">
 </path>
</svg>
    settingComponent = (props: AIProviderSettingsProps) => <AnthropicSettings settings={props.settings}
                                                                              onChange={props.onChange}
                                                                              provider={this}/>
    models = ['claude-3-5-sonnet-20241022', 'claude-3-7-sonnet-20250219']
}